module.exports = __webpack_public_path__ + "static/img/02_マスク着用.e655c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02_マスク着用.png
// module id = 2BaW
// module chunks = 0